import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export const ForcePasswordChange = () => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) { toast.error("New passwords don't match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", {
        current_password: current, new_password: next });
      toast.success("Password updated — welcome aboard!");
      setTimeout(() => window.location.reload(), 600);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Couldn't update password");
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F4F8F8] px-6" data-testid="force-password-change">
      <form onSubmit={submit} className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8">
        <KeyRound className="text-[#0A8B85]" size={28} />
        <h1 className="mt-3 text-xl font-extrabold text-[#0A2540]">Set your new password</h1>
        <p className="mt-1 text-sm text-slate-500">
          You signed in with a temporary password. Choose a new one to continue to your portal.
        </p>
        <input type="password" required value={current} onChange={(e) => setCurrent(e.target.value)}
          placeholder="Temporary password"
          className="mt-5 w-full rounded-lg border border-slate-200 px-3 py-2.5 text-sm outline-none focus:border-[#0A8B85]"
          data-testid="fpc-current-input" />
        <input type="password" required minLength={8} value={next} onChange={(e) => setNext(e.target.value)}
          placeholder="New password (min 8 characters)"
          className="mt-2 w-full rounded-lg border border-slate-200 px-3 py-2.5 text-sm outline-none focus:border-[#0A8B85]"
          data-testid="fpc-new-input" />
        <input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
          placeholder="Confirm new password"
          className="mt-2 w-full rounded-lg border border-slate-200 px-3 py-2.5 text-sm outline-none focus:border-[#0A8B85]"
          data-testid="fpc-confirm-input" />
        <button type="submit" disabled={busy}
          className="mt-4 w-full rounded-xl bg-[#0A8B85] py-2.5 text-sm font-bold text-white hover:bg-[#087a74] disabled:opacity-40"
          data-testid="fpc-submit-btn">
          {busy ? "Updating…" : "Update password & continue"}
        </button>
      </form>
    </div>
  );
};
